import { render, staticRenderFns } from "./DuckSpectrum.vue?vue&type=template&id=270bebc3&scoped=true"
import script from "./DuckSpectrum.vue?vue&type=script&lang=js"
export * from "./DuckSpectrum.vue?vue&type=script&lang=js"
import style1 from "./DuckSpectrum.vue?vue&type=style&index=1&id=270bebc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270bebc3",
  null
  
)

export default component.exports